export const FILE_UPLOAD_METHODS = [
    { name: 'from_device', icon: 'folder', key: 'device' },
    { name: 'from_dropbox', icon: 'dropbox', key: 'dropbox' },
    { name: 'from_google_drive', icon: 'google_drive', key: 'google' },
    { name: 'from_onedrive', icon: 'onedrive', key: 'onedrive' },
    { name: 'from_url', icon: 'link', key: 'url' }
]